export default __webpack_public_path__ + "static/media/bank-account.03bf21cd.svg";